module.exports = __webpack_public_path__ + "static/floralbootieheadband-93e317d7514a7c11288ef2bb12a44ff3.jpeg";